export enum HeroSectionFrontTemplate {
  HERO_SECTION_FRONT = 'hero-section-front',
  HERO_CAMPAIGN = 'hero-campaign'
}
